import * as yup from "yup";
import { useState } from "react";
import { Trans } from "react-i18next";
import { toast } from "react-toastify";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, SubmitHandler } from "react-hook-form";

import Loaing from "../../icons/loaing";
import ConfirmModal from "../ConfirmModal";
import TextArea from "../event-selection/textArea";
import SelectElement from "../event-selection/selectElement";
import { updateEpidemic } from "../../services/epidemicService";
import { closeReporting } from "../../services/dashboardService";
import { EpidemicPdf } from "./epidemic-pdf";
import TextareaAndQmark from "../event-selection/Textare&Qmark";
import DeletePopup from "./delete-popup";
import moment from "moment";
import { UPDATE_VALUES } from "../../data/constants";
import FormDateInput from "../FormDateInput";
import AdminWrapper from "../misc/AdminWrapper";

export type updateEpidemicTypes = {
  _id: string;
  __v: number;
  reporting: string;
  eventDate: string;
  illness: string;
  numberOfChildren: string;
  numberOfTeacher: string;
  printeventDate: boolean;
  actionTaken: string;
  printillness: string;
  printnumberOfChildren: string;
  printnumberOfTeacher: string;
  printactionTaken: string;
  reportingId: string;
  setOpen: (value: boolean) => void;
  updateRecord: (value: any) => void;
  selectedPeriod: string;
};

const schema = yup.object({
  eventDate: yup.string().required(),
  illness: yup.string().required(),
  actionTaken: yup.string().required(),
  numberOfTeacher: yup.string().required(),
  numberOfChildren: yup.string().required(),
});

const UpdateEpidemic: React.FC<updateEpidemicTypes> = ({
  reporting,
  reportingId,
  setOpen,
  updateRecord,
  selectedPeriod,
  ...props
}) => {
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [editEnabled, setEditEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pdfData, setPdfData] = useState<any>(undefined);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [date, setDate] = useState<string>(
    props?.eventDate === "Invalid date" || !props?.eventDate
      ? moment(selectedPeriod).format("YYYY-MM-DD")
      : props.eventDate
  );

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<updateEpidemicTypes>({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props,
    },
  });

  const handleDownload: SubmitHandler<updateEpidemicTypes> = async (data) => {
    data.eventDate = moment(data.eventDate).format("YYYY-MM-DD");
    setPdfData(data);
  };

  const onSubmit: SubmitHandler<updateEpidemicTypes> = async (data) => {
    setLoading(true);
    try {
      const {
        printactionTaken,
        printillness,
        printnumberOfChildren,
        printnumberOfTeacher,
        printeventDate,
        ...rest
      } = data;
      rest.eventDate = moment(data.eventDate).format("YYYY-MM-DD");
      const response = await updateEpidemic(rest, data._id);
      if (response.message === "updated") {
        updateRecord(response?.data);
        toast.success("Your action has been successfully saved!");
        setLoading(false);
        setOpen(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  const resetForm = () => {
    setConfirmModalVisible(false);
    reset();
  };

  const updateReporting = async (value: string) => {
    setLoading(true);
    try {
      const response = await closeReporting(reportingId, { status: value });
      if (response.message === "updated") {
        updateRecord(response.data);
        toast.success("Your action has been successfully saved!");
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  const deleteEvent = (deleteConfirmed: boolean) => {
    if (deleteConfirmed) {
      setOpenDeletePopup(false);
      updateReporting(UPDATE_VALUES.DELETED);
    } else {
      setOpenDeletePopup(false);
    }
  };
  return (
    <section className="relative font-Poppins">
      <AdminWrapper>
        <DeletePopup
          deleteEvent={deleteEvent}
          open={openDeletePopup}
          setOpen={setOpenDeletePopup}
        />
      </AdminWrapper>
      <div>
        <div className="grid gap-3 lg:mx-10">
          <div className="w-16 h-16">
            <img
              src="/images/report.png"
              alt="!"
              className="max-w-full h-auto"
            />
          </div>
          <h1 className="text-4xl font-bold">
            <Trans i18nKey="Epidemic">Epidemic</Trans>
          </h1>
          <p className="text-xl text-[#6B6B6B]">
            <Trans i18nKey="Epidemic_form_message">
              Please note here illness / disease contagious which presented
              itself in at least 4 members of the nursery (children / staff)
              within 10 working days, and had presented a high likelihood of
              infecting other staff and children at the nursery
            </Trans>
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end lg:px-[20px] my-10 gap-[15px]">
          <AdminWrapper>
            {editEnabled && (
              <button
                type="button"
                className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
                onClick={() => setConfirmModalVisible(true)}
              >
                <Trans>Reset</Trans>
              </button>
            )}

            {!editEnabled && (
              <button
                type="button"
                className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
                onClick={() => setEditEnabled(true)}
              >
                <Trans>Edit</Trans>
              </button>
            )}

            <button
              type="button"
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={() => setOpenDeletePopup(true)}
            >
              <Trans>Delete</Trans>
            </button>
            <button
              type="button"
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={() => updateReporting(UPDATE_VALUES.CLOSED)}
            >
              <Trans>Validate</Trans>
            </button>
          </AdminWrapper>
          {pdfData ? (
            <PDFDownloadLink
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              document={<EpidemicPdf formData={pdfData} />}
              fileName={"epidemic.pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Loading..." : "Download PDF"
              }
            </PDFDownloadLink>
          ) : (
            <button
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={handleSubmit(handleDownload)}
            >
              <Trans>Generate PDF</Trans>
            </button>
          )}
        </div>

        <div className="relative z-0 border border-gray-500 lg:mx-5">
          <div className="absolute -top-3 left-5 lg:-top-5 lg:left-14 bg-[white] px-[20px] lg:px-5">
            <h1 className="text-sm lg:text-3xl font-bold text-[#1E408E]">
              <Trans i18nKey="Event Details">Event Details</Trans>
            </h1>
          </div>
          <div className="md:p-16 sm:p-8 p-4 pt-16">
            <div className="grid gap-5">
              <FormDateInput
                type="Date"
                register={register}
                errors={errors}
                name="eventDate"
                printEnabled
                label="Event date"
                placeholder=""
                translateId="Event date"
                disabled={!editEnabled}
                date={date}
                setDate={setDate}
                control={control}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="illness"
                label="Illness/Infections"
                printEnabled
                options={[
                  "Bronchitis",
                  "Conjonctivitis",
                  "Covid-19",
                  "Flo/Cold",
                  "Gastroenteritis",
                  "Hand Foot and Mouth",
                  "Hepatitis A",
                  "Viral infection",
                  "Tinea Corporis",
                  "Varicella",
                  "Other",
                ]}
                translateId="illness"
                disabled={!editEnabled}
              />
              <TextareaAndQmark
                register={register}
                errors={errors}
                printEnabled
                name="numberOfChildren"
                label="Number of Children"
                translateId="numberOfChildren"
                disabled={!editEnabled}
                i18nKey="Help Box - Epidemic - Number of children infected"
              />
              <TextareaAndQmark
                register={register}
                errors={errors}
                printEnabled
                name="numberOfTeacher"
                label="Number of Teacher/Adult infected"
                translateId="Number of Teacher or Adult infected"
                disabled={!editEnabled}
                i18nKey="Help Box - Epidemic - Number of teacher/adult infected"
              />

              <TextArea
                register={register}
                errors={errors}
                name="actionTaken"
                label="Actions Taken"
                printEnabled
                translateId="actionTaken"
                disabled={!editEnabled}
              />
            </div>
          </div>
        </div>
        <AdminWrapper>
          <div className="flex justify-end lg:px-[20px] my-10">
            <button
              type={"submit"}
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
            >
              <Trans i18nKey="Submit">Submit</Trans>
            </button>
            {loading && <Loaing />}
          </div>
        </AdminWrapper>
      </form>
      <ConfirmModal
        isOpen={confirmModalVisible}
        setIsOpen={setConfirmModalVisible}
        onConfirm={resetForm}
      />
    </section>
  );
};

export default UpdateEpidemic;
